import { useEffect } from "react";
import { usePublicConfig } from "@/lib/usePublicConfig";

/**
 * PixelInjector — leest tracking IDs uit /api/public-config en injecteert pixels
 * in document.head ALLEEN als de gebruiker cookie-consent gaf voor marketing.
 */
export default function PixelInjector() {
  const cfg = usePublicConfig();

  useEffect(() => {
    if (!cfg) return;
    const consent = localStorage.getItem("ce_cookie_consent");
    if (consent !== "all") return;
    const t = cfg.tracking || {};

    // Google Analytics 4
    if (t.google_analytics && !window.ga4Injected) {
      window.ga4Injected = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${t.google_analytics}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${t.google_analytics}');`;
      document.head.appendChild(inline);
    }

    // Facebook Pixel
    if (t.facebook_pixel && !window.fbqInjected) {
      window.fbqInjected = true;
      const fbScript = document.createElement("script");
      fbScript.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${t.facebook_pixel}');fbq('track','PageView');`;
      document.head.appendChild(fbScript);
    }

    // TikTok Pixel
    if (t.tiktok_pixel && !window.ttqInjected) {
      window.ttqInjected = true;
      const tt = document.createElement("script");
      tt.innerHTML = `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('${t.tiktok_pixel}');ttq.page();}(window, document, 'ttq');`;
      document.head.appendChild(tt);
    }

    // LinkedIn Insight
    if (t.linkedin_insight && !window.liInjected) {
      window.liInjected = true;
      const li = document.createElement("script");
      li.innerHTML = `_linkedin_partner_id = "${t.linkedin_insight}"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);`;
      document.head.appendChild(li);
      const lib = document.createElement("script");
      lib.async = true;
      lib.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      document.head.appendChild(lib);
    }
  }, [cfg]);

  return null;
}
